import { type HTMLAttributes, type ReactNode } from 'react'
import { LabelBadge } from '@/components/base/LabelBadge'
import { Rings } from '@/components/composite/Rings'
import {
  checkInItemVariants,
  checkInItemTextVariants,
  CheckInItemRingVariants
} from './CheckInItem.variants'
import type { CheckInStatus } from './types'

export interface CheckInItemProps extends HTMLAttributes<HTMLDivElement> {
  title: string
  boostPercent: number
  boostLabel: string
  status: CheckInStatus
  cta?: ReactNode
}

export const CheckInItem = ({
  title,
  boostPercent,
  boostLabel,
  status,
  cta,
  className,
  ...props
}: CheckInItemProps) => {
  const isActive = status === 'unused' || status === 'auto' || status === 'used'
  const accentColor = status === 'used' ? 'green' : 'yellow'
  const { boost, label } = checkInItemTextVariants({ status })

  return (
    <div className={checkInItemVariants({ status, className })} {...props}>
      <div className="absolute inset-0 overflow-hidden">
        <div className={CheckInItemRingVariants({ status })}>
          {isActive ? (
            <Rings accentColor={accentColor} variant="gradient" />
          ) : (
            <Rings variant="gradient" />
          )}
        </div>
      </div>

      <div className="relative flex flex-col flex-shrink-0 items-center justify-between gap-3 z-20">
        <LabelBadge accentColor={accentColor} active={isActive} label={title} />

        <div className="flex flex-col items-center gap-1 [text-shadow:0px_1px_1px_rgba(0,0,0,0.25)]">
          <div className={boost()}>{`${boostPercent}%`}</div>
          <div className={label()}>{boostLabel}</div>
        </div>

        {cta}
      </div>
    </div>
  )
}

CheckInItem.displayName = 'CheckInItem'
